var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vue-multiselect",
        {
          attrs: {
            id: _vm.id,
            options: _vm.options,
            searchable: true,
            "allow-empty": _vm.allowEmpty,
            label: _vm.labelName,
            "track-by": _vm.trackByName,
            placeholder: _vm.placeholderText,
            "select-label": _vm.labelSelect,
            "deselect-label": _vm.labelDeselect,
            "selected-label": _vm.labelSelected,
            disabled: _vm.disabled,
            "show-labels": _vm.showLabels,
            "custom-label": _vm.customLabel,
            name: _vm.name,
            "options-limit": _vm.optionsLimit
          },
          on: {
            select: function($event) {
              return _vm.$emit("dispatch", $event)
            }
          },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        },
        [
          _c("span", { attrs: { slot: "noResult" }, slot: "noResult" }, [
            _vm._v("Brak wyników. Spróbuj zmienić wpisywaną frazę.")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-110290af", { render: render, staticRenderFns: staticRenderFns })
  }
}